export default (wireModel) => ({
    dragging: false,
    isUploading: false,
    error: null,
    wireModel,
    progress: 0,
    validTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
    file: null,
    open: false,

    init(){
        this.$watch('file', value => value ? this.uploadFile() : '');
        this.$watch('wireModel', value => value ? '' : this.removeFile());
    },

    changeHandler({ target }) {
        if(! target.files){
            return;
        }

        this.file = Array.from(target.files).shift();
    },

    dragoverHandler(event){
        event.preventDefault();
        this.dragging = true;
    },

    dragleaveHandler(){
        this.dragging = false;
    },

    dropHandler(event){
        event.preventDefault();
        let files = [];

        if(event.dataTransfer.files){
            files = [...event.dataTransfer.files]
                .filter(file => ! this.validTypes.includes(file));
        }

        if(files.length > 0){
            this.file = files.shift();
        }

        this.dragging = false;
    },

    uploadFile(){
        if(!this.file){
            return;
        }

        this.isUploading = true;

        this.$wire.upload('image', this.file, (uploadedFilename) => {
            this.isUploading = false;
            this.error = null;
            this.file.uploadedName = uploadedFilename;
        }, () => {
            this.progress = 0;
            this.isUploading = false;
            this.error = 'Error trying to upload the file!';
        }, (event) => {
            this.progress = event.detail.progress;
        });
    },

    removeFile() {
        if(this.file && this.file.hasOwnProperty('uploadedName')){
            this.$wire.removeUpload('image', this.file.uploadedName);
        }

        document.getElementById('inputFile').value = null
        this.file = null;
        this.isUploading = false;
        this.progress = 0;
        this.error = null;
        this.dragging = false;
    },
});
